package com.clany.backoffice.domain.usecase

import com.clany.backoffice.domain.repository.InvitationRepository
import com.clany.backoffice.model.InvitationResponse
import dev.zacsweers.metro.Inject

class GetInvitationsUseCase @Inject constructor(
    private val repository: InvitationRepository
) {
    suspend operator fun invoke(
        page: Int = 1,
        pageSize: Int = 20,
        query: String? = null
    ): Result<List<InvitationResponse>> = repository.getInvitations(page, pageSize, query)
}
